import { Button } from '@populix/pop-ui'
import React from 'react'

type TPrescreeningProgress = {
  readonly totalStep: number
  readonly currentStep: number
  readonly onClickPrev: () => void
  readonly onClickNext: () => void
  readonly onClickSubmit: () => void
  readonly submitBtnLabel?: string
  readonly disabled?: boolean
  readonly isLastQuestion: boolean
}

export default function PrescreeningProgress({
  onClickPrev,
  onClickNext,
  onClickSubmit,
  submitBtnLabel,
  disabled,
  isLastQuestion,
  currentStep,
}: TPrescreeningProgress) {
  return (
    <div
      className={`fixed bottom-0 mx-auto flex w-full max-w-xl gap-4 ${
        currentStep === 0 ? 'justify-end' : 'justify-between'
      }  border border-white bg-white px-5 py-4`}
    >
      {currentStep > 0 && (
        <div className='w-full md:max-w-[165px]'>
          <Button
            variant='text'
            type='button'
            onClick={onClickPrev}
            aria-label='Previous'
            disabled={disabled}
            disabledVarian='disabled'
          >
            Previous
          </Button>
        </div>
      )}

      {!isLastQuestion && (
        <div className={`w-full md:max-w-[165px]`}>
          <Button
            variant='contained'
            type='button'
            onClick={onClickNext}
            aria-label='Next'
            disabled={disabled}
            disabledVarian='loading'
          >
            Next
          </Button>
        </div>
      )}

      {isLastQuestion && (
        <div className={`w-full md:max-w-[165px] `}>
          <Button
            variant='contained'
            type='button'
            onClick={onClickSubmit}
            aria-label='Submit'
            disabled={disabled}
            disabledVarian='loading'
          >
            {submitBtnLabel || 'Submit'}
          </Button>
        </div>
      )}
    </div>
  )
}
